import Marquee from "react-fast-marquee";

export function EditorialMarquee() {
  const items = ["BKG GLOBAL", "FUTURE OBJECTS", "DARK LUXURY", "ELECTRIC LIVING"];
  return (
    <section className="border-y border-white/10 py-8" data-testid="editorial-marquee">
      <Marquee speed={28} gradient={false}>
        {items.map((item) => (
          <span key={item} className="mx-8 font-heading text-7xl font-black italic tracking-tighter text-outline md:text-8xl">
            {item} <span className="mx-8 text-volt">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
